import MasterCrud from "@/components/MasterCrud";
import { Hash } from "lucide-react";

export default function HsnMaster() {
  return (
    <MasterCrud
      endpoint="/hsn-codes"
      slug="hsn"
      title="HSN Code Master"
      subtitle="Inventory · HSN codes with GST rates"
      icon={Hash}
      importKey="hsn-codes"
      fields={[
        ["hsn_code", "HSN Code"],
        ["description", "Description"],
        ["cgst", "CGST %", "number"],
        ["sgst", "SGST %", "number"],
        ["igst", "IGST %", "number"],
        ["total_gst", "Total GST %", "computed", (r) => (Number(r.cgst) || 0) + (Number(r.sgst) || 0)],
      ]}
    />
  );
}
